// ═══════════════════════════════════════════════════════════════════════════
// filtrosDeQuery — los `where` de un array de filtros declarativos
// ───────────────────────────────────────────────────────────────────────────
// Una sola definición para los tres hooks que reciben `filters`
// (`useDashboardData`, `usePaginatedCollection`, `useFacetCounts`). Hasta el
// paso 5 del ADR 2026-10-21 («los filtros de los hooks declarativos se
// escriben como listas literales nombradas…») cada uno tenía su copia del
// mismo loop, y las tres DESCARTABAN EN SILENCIO un filtro con
// `value === undefined`: el call site decía una query y a Firestore llegaba
// otra, sin ese `where` — o sea más datos de los pedidos y otra combinación
// de índice. Ahora falla cerrado: el hook que lo llama queda en error y no
// consulta.
//
// `null` NO es `undefined`: pasa y arma un `where(campo, op, null)`, que es
// una query válida. Quien no quiera el filtro elige la lista que no lo tiene
// (ternario entre dos nombres) o apaga la lectura con `enabled`.
//
// Las entradas mal formadas (sin `field` u `op`, o que no son objeto) se
// siguen salteando, como antes: no son una forma de query, son basura.
// ═══════════════════════════════════════════════════════════════════════════

import { where } from 'firebase/firestore'

/**
 * @param {Array<{field: string, op: string, value: *}>} filters
 * @returns {Array} los `where()` de cada entrada bien formada, en orden.
 * @throws {Error} si una entrada bien formada trae `value === undefined`.
 */
export function wheresDeFiltros(filters = []) {
  const wheres = []
  for (const f of filters) {
    if (!f || !f.field || !f.op) continue
    if (f.value === undefined) {
      throw new Error(`filtro '${f.field}' ${f.op} sin valor (undefined): la query no se arma — elegí la lista sin ese filtro o apagá la lectura con enabled`)
    }
    wheres.push(where(f.field, f.op, f.value))
  }
  return wheres
}
